import {Component, OnInit} from '@angular/core';
import {CallBackEndService} from '../call-back-end.service';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SessionTimerComponent } from '../session-timer/session-timer.component';
declare var getHexAscii: any;


@Component({
  selector: 'app-adhaar-update',
  templateUrl: './adhaar-update.component.html',
  styleUrls: ['./adhaar-update.component.css']
})
export class AdhaarUpdateComponent implements OnInit {
  isShow: string = 'hide';
  AadharNotblankstatus: string = '';
  AadharNotSpacestatus: string = '';
  AadharNumberstatus: string = '';
  Aadharspecialstatus: string = '';
  Aadharcharstatus: string = '';
  onlyadharZeroes: string = '';
  AadharNOlength: string = '';
  AadharNotsame: string = '';
  AadharNotBlank: string = '';
  isError: string = '';
  isLoad: boolean = true;
  disabled: boolean = true;
  getOtpResp: any;
  otpNull : string ='';
  isDisable : boolean=false;
  custNoAdhar: string =sessionStorage.getItem('custNo');
  userNameAdhar: string =sessionStorage.getItem('storedUserName');
  adhaarNo: string = '';
  otp: string = '';
  disablenextBtn:boolean=false;
  disablesubBtn:boolean=false;
  //otpDetails1: any;
  user1 : string ='';
  otp1 : string ='';
  confirmAdhaarNo: string = '';
  message : string ='';
  otpinvalid : string='';
  otpError: string;

  isActive: boolean;

   reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/;
   regNum = /^[0-9]+$/;
   regchar = '/^[a-zA-Z]+$/';
   regexpspace = /\s+/;

   regNumsOnly =/^\d+$/;
  errorMsgFromBackend: string;

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService,private timer: SessionTimerComponent) {}
  //functiobn for otp generation
  getOtp() {

    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii("", this.userNameAdhar );
    request.param2 = this.userNameAdhar;
    var reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^[0-9]+$/;
    var regchar = '/^[a-zA-Z]+$/';
    var regexpspace = /\s+/;
    var onlyZeroes = '^[0][0]*[0]$';
    var onlyadharZeroes = '000000000000';
    if(this.adhaarNo==='' || this.adhaarNo===undefined)
      {
      this.AadharNotblankstatus='no';
        this.isDisable=false;
    }else
    if (this.adhaarNo === undefined || this.adhaarNo === "") {
      this.AadharNotblankstatus = 'no';
      //this.disabled = true;
        //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo === " " || this.adhaarNo.indexOf(' ') !== -1) {
      this.AadharNotSpacestatus = 'no';
      this.disabled = true;
     // this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (!this.adhaarNo.match(regNum)) {
      this.AadharNumberstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(reg)) {
      this.Aadharspecialstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(regchar)) {
      this.Aadharcharstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(onlyadharZeroes)) {
      this.onlyadharZeroes = 'no';
      this.disabled = true;
     // this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.length > 12 || this.adhaarNo.length < 12) {
      this.AadharNOlength = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if(this.confirmAdhaarNo==='' || this.confirmAdhaarNo===undefined)
      {
      this.AadharNotBlank='no';
        this.isDisable=false;
    } else if (this.confirmAdhaarNo !== this.adhaarNo) {
      this.AadharNotsame = 'no';
      this.disabled = true;
        this.disablenextBtn=false;
      this.isDisable=false;
    }
    else
      {
        this.disablenextBtn=true;
         this.spinnerService.show();
    this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
       this.spinnerService.hide();
      this.isLoad = false;
	  this.disabled = true;
	  console.log(data.status);
      if (data.status === 'S101') {
		    console.log('mal request');
		 // console.log('Malicious Request Detected');
		  this.timer.logout();
		//alert('Malicious Request Detected');
		this.isLoad = false;
		this.timer.logout();
      } if (data.status === 'S200') {
        this.getOtpResp = data;
        //console.log('Otp :' + this.getOtpResp.param1);
        this.isShow = 'show';
      }
    });
    }
  }
  //this method is used to update adhar number
  updateAdhaarNo() {
  if(this.validateOtp()){
    this.isError = '';
    const request: IbRequest = new IbRequest();

    const otpInfo: any = {
        'userName': this.userNameAdhar,
        'otp': getHexAscii("", this.otp)
      };
    // if(this.otp === '' || this.otp === undefined)
    //   {
    //   this.otpNull='no';
    // }
    if (this.userNameAdhar && this.custNoAdhar && this.adhaarNo && this.otp) {
        this.disablesubBtn=true;
      //console.log("only param 6 isss "+otpDetails1);
      console.log("beforre "+this.custNoAdhar+this.adhaarNo+this.userNameAdhar+this.otp);
       this.spinnerService.show();
      request.param1 = getHexAscii("", this.custNoAdhar + this.adhaarNo + this.userNameAdhar + this.otp);
      request.param2 = this.custNoAdhar;
      request.param3 = this.adhaarNo;
      request.param6 = otpInfo;
      console.log("param 6 isss "+otpInfo);
      this.webService.getResponse(request, 'updateAdhaarNo').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        this.isLoad = false;
        this.disabled = true;
        if (data.status === 'S101') {
          alert('Malicious Request Detected');
          this.isLoad = false;
        } else if (data.status === 'S200') {
          this.getOtpResp = data;
          console.log('response :' + this.getOtpResp.param1);

          this.isShow = 'successpage';
          this.message=this.getOtpResp.param1;
        }
        else if(data.status === 'S333')
        {
            this.disablesubBtn=false;
         // this.isShow = 'show';
          //this.otpinvalid='no';
          this.otpError='backendError';
          this.errorMsgFromBackend = data.param1+'';

        }
        else if(data.status === 'S334')
        {
            this.disablesubBtn=false;
         // this.isShow = 'show';
          this.otpError='backendError';
          this.errorMsgFromBackend = data.param1+'';
        }
        else if(data.status === 'ADHAARNO_ALREADY_EXIST'){

          this.isShow='errorpage';
          this.message=data.param1;
        }
        else
          {
            this.message=this.getOtpResp.param1;
           this.getOtpResp = data;
             this.disablesubBtn=false;
          console.log('error  :' + this.getOtpResp.param1);
          this.isShow = 'errorpage';
            this.isError='error';
        }
      });
    }
  }
}
  back() {
    this.isShow = 'hide';
    this.otp = '';
    this.otpinvalid='';
    this.otpNull='';
    this.disablenextBtn=false;

    this.adhaarNo='';
    this.confirmAdhaarNo='';


  }

  validateOtp(){ 
    if(this.otp==='' || this.otp===' ' || this.otp===null || this.otp===undefined ){
      this.otpError='yes';
      return false;
    }else if(!this.otp.match(this.regNumsOnly)){
      this.otpError='nums';
      return false;
    }
    return true;
  }

  removeMessages() {
    this.otpError='';
    console.log('isActive val: '+this.isActive);
    this.disabled = false;
    this.otpNull= '';
    this.otpinvalid='';
    this.message='';
  }

  getAadharNumber() {

    var reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regNum = /^[0-9]+$/;
    var regchar = '/^[a-zA-Z]+$/';
    var regexpspace = /\s+/;
    var onlyZeroes = '^[0][0]*[0]$';
    var onlyadharZeroes = '000000000000';
    if (this.adhaarNo === undefined || this.adhaarNo === "") {
      this.AadharNotblankstatus = 'no';
      //this.disabled = true;
        //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo === " " || this.adhaarNo.indexOf(' ') !== -1) {
      this.AadharNotSpacestatus = 'no';
      this.disabled = true;
     // this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (!this.adhaarNo.match(regNum)) {
      this.AadharNumberstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(reg)) {
      this.Aadharspecialstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(regchar)) {
      this.Aadharcharstatus = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.match(onlyadharZeroes)) {
      this.onlyadharZeroes = 'no';
      this.disabled = true;
     // this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.adhaarNo.length > 12 || this.adhaarNo.length < 12) {
      this.AadharNOlength = 'no';
      this.disabled = true;
      //this.disablenextBtn=false;
      this.isDisable=false;
    }
  }

  removeMessagesAdhar() {
    this.AadharNotblankstatus = '';
    this.AadharNotSpacestatus = '';
    this.Aadharspecialstatus = '';
    this.AadharNumberstatus='';
    this.Aadharcharstatus = '';
    this.onlyadharZeroes = '';
    this.AadharNOlength = '';
    this.disabled = false;
    this.isDisable=true;
  }

  getValidAadharNumber() {
    if (this.confirmAdhaarNo === undefined || this.confirmAdhaarNo === "") {
      this.AadharNotBlank = 'no';
      this.disabled = true;
        this.disablenextBtn=false;
      this.isDisable=false;
    }
    else if (this.confirmAdhaarNo !== this.adhaarNo) {
      this.AadharNotsame = 'no';
      this.disabled = true;
        this.disablenextBtn=false;
      this.isDisable=false;
    }
  }

  removeValidMessagesAdhar() {
    this.AadharNotBlank = '';
    this.AadharNotsame = '';
    this.disabled = false;
      this.disablenextBtn=false;
    this.isDisable=true;
  }

  ngOnInit() {
   
  }
ok()
{
  this.isShow='hide';
  this.disablenextBtn=false;
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/adhaar-update/adhaar-update.component.ts